import React from 'react';

import { GeneralBillingTabs } from 'src/components/account';
import { DetailPageLayout } from 'src/components/common';
import { EmployerBillingRulesChange, VerifierBillingRulesChange } from 'src/modals/billing';

export const GeneralBillingRulesPage: React.FC = () => {
  return (
    <DetailPageLayout titleContent="General Billing Rules">
      <GeneralBillingTabs />
      <EmployerBillingRulesChange />
      <VerifierBillingRulesChange />
    </DetailPageLayout>
  );
};
